import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "ml10" }
const _hoisted_4 = { class: "color-danger" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "action-list" }

import { getCurrentInstance, onActivated, reactive, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRouter } from 'vue-router'
import Pagination from '@/components/Pagination.vue'
import { getShopUserListApi } from '@/apis/merchant'
import { updateRefundSplitAgreeApi, getRefundListApi } from '@/apis/order'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
import { UserType } from '@/enums/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'RefundOrderList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore() as any
const groupString = store.state.user.userInfo.group_id
const groupArray = groupString.split(',')
const { user_type } = store.state.user.userInfo

const filters = reactive({
    shop_user_id: '',
    status: '',
    order_no: '',
    name: '',
    phone: '',
    start_date: '',
    end_date: '',
    group_id: groupString,
    page: 1,
    page_size: 10,
})

const shopUserList = ref([])
const getShopUserList = async () => {
    const {code, data, msg} = await getShopUserListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    shopUserList.value = data
}
getShopUserList()

const tableData = ref<any>([])
const total = ref(0)
const srcList = ref<string[]>([])
const getList = async () => {
    const {code, data, msg} = await getRefundListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    tableData.value = data.data
    total.value = data.total
}
getList()

// 搜索
const onSearch = () => {
    filters.page = 1
    getList()
}

// 导出
const onExport = () => {
    window.open(`${Keys.baseUrl}/admin/merchant/getOrderRefundBearList?${joinParams({ ...filters, user_id: store.state.user.userInfo.id, is_export: 1 })}`);
}

// 商户端：同意/拒绝
const onSubmit = async (id, type: number) => {
    const { code, data, msg } = await updateRefundSplitAgreeApi(id, type) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    proxy.$message({ type: 'success', message: '操作成功' })
    getList()
}

// 一键复制
const copyOrderInfo = async (row: any) => {
    // 映射产品列表并构建每个产品的详细信息字符串
    const productListDetails = row.order_items.map(product => {
        // 使用 || 运算符来处理null、undefined和空字符串
        return `
        商品名称：${product.product_name || '无'}
        规格：${product.spec_name || '无'}
        单价：${product.price || '无'}
        数量：${product.quantity || '无'}
        `;
    }).join('\n'); // 使用换行符连接每个产品的信息

    const orderInfo = `
    订单号：${row.order_no || '无'}
    收货人姓名：${row.name || '无'}
    收货人手机号：${row.phone || '无'}
    品牌：${row.brand_name || '无'}
    运费：${row.ship_amount || 0}元
    订单金额：${row.total_amount || 0}元
    退款原因：${row.repund_why || '无'}
    承担方：${row.bear_to}：${row.business_bear} 元，蛋叔平台：${row.platform_bear}元
    商品信息：${productListDetails}
    `;
    navigator.clipboard.writeText(orderInfo).then(() => {
        proxy.$message({type:'success',message:'复制成功'});
    }).catch(err => {
        proxy.$message({type:'error',message:err});
    });
}

const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onActivated(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(UserType)[_unref(user_type)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_select_v2, {
            key: 0,
            class: "filter-item",
            modelValue: filters.shop_user_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.shop_user_id) = $event)),
            filterable: "",
            clearable: "",
            options: shopUserList.value,
            props: {
                    value: 'id',
                    label: 'shop_description'
                },
            placeholder: "商户列表",
            style: {"width":"150px"}
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "操作状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 0,
            label: "待处理"
          }),
          _createVNode(_component_el_option, {
            value: 1,
            label: "已同意"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "不同意"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.order_no) = $event)),
        modelModifiers: { trim: true },
        placeholder: "订单号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "收货人",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.phone,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "手机号",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "支付开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "支付结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("批量导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: "",
      class: "data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_no",
          label: "订单号"
        }),
        _createVNode(_component_el_table_column, {
          label: "商品信息",
          width: "340"
        }, {
          default: _withCtx((scope) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.order_items, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "goods-item"
              }, [
                _createVNode(_component_el_image, {
                  style: {"width":"80px","height":"80px"},
                  src: item.image_path,
                  "preview-src-list": srcList.value,
                  fit: "cover",
                  onClick: ($event: any) => (srcList.value = [item.image_path]),
                  "z-index": 1000,
                  "preview-teleported": true
                }, null, 8, ["src", "preview-src-list", "onClick"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", null, "品牌：" + _toDisplayString(scope.row.brand_name), 1),
                  _createElementVNode("p", null, "商品：" + _toDisplayString(item.product_name), 1),
                  _createElementVNode("p", null, "规格：" + _toDisplayString(item.spec_name), 1)
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "单价/数量" }, {
          default: _withCtx((scope) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.order_items, (item) => {
              return (_openBlock(), _createElementBlock("p", {
                key: item.id
              }, [
                _createTextVNode(_toDisplayString(`${item.price}`) + " /", 1),
                _createElementVNode("b", _hoisted_4, _toDisplayString(`${item.quantity}`), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ship_amount",
          label: "运费"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "订单金额"
        }),
        _createVNode(_component_el_table_column, { label: "发货信息" }, {
          default: _withCtx((scope) => [
            _createTextVNode(" 收货人：" + _toDisplayString(scope.row.name), 1),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
            _createTextVNode("手机号：" + _toDisplayString(scope.row.phone), 1),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            (scope.row.status == 3)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "退款时间:" + _toDisplayString(scope.row.refund_time), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "repund_why",
          label: "退款原因"
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_amount",
          label: "承担方"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("p", null, _toDisplayString(scope.row.bear_to) + " " + _toDisplayString(scope.row.business_bear) + "元，蛋叔平台 " + _toDisplayString(scope.row.platform_bear) + " 元", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "商户状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status == 0 ? '待处理' : scope.row.status == 1 ? '已同意' : '不同意'), 1)
          ]),
          _: 1
        }),
        (!_unref(groupArray).includes('5'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作",
              width: "153",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_6, [
                  (_unref(UserType)[_unref(user_type)] === '合作商户')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: ($event: any) => (onSubmit(scope.row.id, 1)),
                          disabled: scope.row.status == 1
                        }, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("同意")
                          ])),
                          _: 2
                        }, 1032, ["onClick", "disabled"]),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: ($event: any) => (onSubmit(scope.row.id, 2)),
                          disabled: scope.row.status == 1 || scope.row.status == 2 && scope.row.handle_status == 0
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("不同意")
                          ])),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: ($event: any) => (copyOrderInfo(scope.row))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode("一键复制")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: ($event: any) => (_unref(router).push('/merchant-admin/order-edit?order_id=' + scope.row.order_id)),
                          disabled: scope.row.status == 1 || scope.row.handle_status == 1
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("处理")
                          ])),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ], 64))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"])
  ]))
}
}

})